import PropTypes from 'prop-types';
import React from 'react';
import { findDOMNode } from 'react-dom';
import PopoverComponent from "../../base-component/popover-component";

import Popover from 'src/core/gd-components/gd-popover/popover';

import Classes from 'classnames';

const propTypes = {
    optionComponent: PropTypes.func.isRequired,
    options: PropTypes.array,
    addLabel: PropTypes.string,

    onUserSelect: PropTypes.func,
    onClickAdd: PropTypes.func
};

const defaultProps = {
    options: []
};

class SelectorMoreComponent extends PopoverComponent {

    constructor(props) {
        super(props);

        this._bind('onOptionClick', 'onClickAdd');
    }

    onOptionClick(id) {
        const { disabled, onUserSelect } = this.props;
        if ( disabled ) return;

        if (!id) id = 'all';
        this.hidePopover(null,()=>{
            if (onUserSelect) onUserSelect(id);
        });
    }

    onClickAdd() {
        this.hidePopover(null,()=>{
            const { onClickAdd } = this.props;
            if (onClickAdd) onClickAdd();
        });
    }

    renderPopover() {
        const { options, optionComponent: OptionComponent, addLabel, onClickAdd } = this.props;
        const { showPopover } = this.state;

        if (showPopover) {
            return (
                <Popover popoverClass="gd-selector2-more-component-popover"
                         className="gd-selector2-more-component-popover-container"
                         attachment="top center"
                         targetAttachment="bottom center"
                         onClickOutside={()=>{this.hidePopover()}}
                         getTargetFunc={()=>findDOMNode(this)}>

                    {options.map(o=><OptionComponent key={o.value}
                                                     value={o.value}
                                                     icon={o.icon}
                                                     iconObj={o.iconObj}
                                                     label={o.label}
                                                     parent={this}/>)}

                    <div className="cf"> </div>

                    {onClickAdd &&
                    <div className="add-label" onClick={this.onClickAdd}>
                        <div className="add-label-icon i5-plus"> </div>{addLabel}
                    </div>}

                </Popover>
            );
        }
    }

    render() {
        const componentClasses = Classes('gd-selector2-more-component', this.props.className);

        return (
            <div className={componentClasses}
                 onClick={this.showPopover}>
                <div className="gd-selector2-more-component-icon i5-more"> </div>
                {this.renderPopover()}
            </div>
        );
    }
}

SelectorMoreComponent.propTypes = propTypes;
SelectorMoreComponent.defaultProps = defaultProps;

module.exports = SelectorMoreComponent;
